module.exports = __webpack_public_path__ + "static/media/poweredby_goledger.1a9bc37c.svg";